/**
 * +zone: per-map terrain for open maps that have one (the renderer's ground, units and camera; the
 * sim stays 2D). Maps without terrain keep the Phase 1 look (flat walkable ground, hills beyond).
 */
import { MAP } from './ids';
import { MOSSVALE_WATER, mossvaleHeight } from './mossvaleTerrain';

export interface FieldTerrain {
  /** Height (yd) at sim (x, y), everywhere (walkable or not). */
  heightAt(x: number, y: number): number;
  water: typeof MOSSVALE_WATER | null;
}

const TERRAINS: Record<string, FieldTerrain> = {
  [MAP.mossvale]: { heightAt: mossvaleHeight, water: MOSSVALE_WATER },
};

export function fieldTerrainOf(mapId: string): FieldTerrain | null {
  return TERRAINS[mapId] ?? null;
}
